/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import LHSectionHeader from "../../components/LHSectionHeader";
import LHMiscellaneousObservations from "../../components/LHMiscellaneousObservations.fixed.new";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../../theme";

const styles = StyleSheet.create({
  cardContainer: {
    borderRadius: 6,
    overflow: 'hidden',
    elevation: 4,
    shadowColor: 'rgba(0, 94, 192, 0.08)',
    shadowOffset: { width: 4, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 24,
    marginTop: 12,
    marginBottom: 24,
    backgroundColor: 'transparent',
  },
  sectionHeader: {
    backgroundColor: '#3582E6',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  header1text: {
    fontSize: 16,
    color: 'white',
    fontWeight: 'bold',
  },
  contentContainer: {
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    backgroundColor: 'white',
    borderColor: '#e9ecef',
    borderWidth: 1,
    borderTopWidth: 0,
    padding: 16,
  },
});

const ShiftHandOverMiscellaneousObservations: React.FC<{ forceDisabled?: boolean }> = ({ forceDisabled = false }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  const handoverState = useSelector(
    (state: RootState) => state.shiftHandOver.handoverState
  );
  return (
    <View
      style={[
        styles.cardContainer,
        isDarkMode && {
          backgroundColor: colors.background.surface,
          borderColor: colors.border.default,
          borderWidth: 1,
        },
      ]}
    >
      <LHSectionHeader
        title="Miscellaneous Observations"
        containerStyle={
          isDarkMode
            ? { ...styles.sectionHeader, backgroundColor: colors.brand.primary }
            : styles.sectionHeader
        }
        textStyle={styles.header1text}
        // icon={<MaterialIcons name="photo-camera" size={20} color="white" />}
      />
      <View
        style={[
          styles.contentContainer,
          isDarkMode && {
            backgroundColor: colors.background.surface,
            borderColor: colors.border.default,
          },
        ]}
      >
        <LHMiscellaneousObservations
          disabled={handoverState === "completed" || forceDisabled}
          stateKey="shiftHandOver"
          containerName="shifthandover"
        />
      </View>
    </View>
  );
};

export default ShiftHandOverMiscellaneousObservations;
